module.exports = __webpack_public_path__ + "d1c7039f6edc1d36b9390779190fd82a.jpg";